import * as React from 'react'
import { SVGProps } from 'react'
const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg width={100} stroke="#000" height={100} viewBox="0 0 100 100" {...props}>
    <path d="M20 50h60M50 20v60" strokeWidth={8} />
  </svg>
)
export default SvgPlus
